module.exports = __webpack_public_path__ + "static/cactus-people-e6a439e9fb30ce0b6c92040877e925c7.jpg";